(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      // Bound once so disconnectedCallback can remove the exact same listener instances (the
      // pre-existing 990px one previously leaked on every Theme Editor reconnect - fixed here
      // rather than duplicated by the new 749px listener).
      this.setHeaderHeightHandler = this.setHeaderHeight.bind(this);
      this.desktopMediaQuery = window.matchMedia('(max-width: 990px)');
      this.desktopMediaQuery.addEventListener('change', this.setHeaderHeightHandler);
      // Topbar itself toggles visibility at 749px (.small-hide, topbar.liquid) - a resize that
      // crosses only this breakpoint (e.g. 600px -> 800px, both under 990px) wouldn't otherwise
      // trigger a recalculation, leaving --hero-pull-up-height stale relative to whether the
      // topbar is actually showing.
      this.topbarMediaQuery = window.matchMedia('(max-width: 749px)');
      this.topbarMediaQuery.addEventListener('change', this.setHeaderHeightHandler);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      // --header-height: header's own height only. Consumed site-wide by base.css's sticky
      // hide/reveal offset (.shopify-section-header-hidden) - must stay scoped to just the header,
      // or the hide/reveal scroll distance would change on every page, not only the homepage.
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);

      // --hero-pull-up-height: header + topbar combined, for the homepage-only hero pull-up
      // margin (topbar is a separate sibling section, not part of .section-header, and isn't
      // sticky - it's just measured here for its static height at page load).
      const topbar = document.querySelector('.section-topbar');
      const topbarHeight = topbar ? topbar.offsetHeight : 0;
      document.documentElement.style.setProperty('--hero-pull-up-height', `${this.header.offsetHeight + topbarHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.desktopMediaQuery.removeEventListener('change', this.setHeaderHeightHandler);
      this.topbarMediaQuery.removeEventListener('change', this.setHeaderHeightHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
